import { Check, Star } from "lucide-react";
import Thumbnail from "@/components/studio/Thumbnail";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Ganadora y reservas de una ráfaga lado a lado; un toque cambia la elegida.
export default function BurstCompare({ burst, reason, disabled, onChoose, onClose }) {
  const shown = burst ? burst.photos.filter(p => p.selectedForEdit || p.isReserve).sort((a, b) => Number(!!b.selectedForEdit) - Number(!!a.selectedForEdit)) : [];
  return (
    <Dialog open={!!burst} onOpenChange={o => { if (!o) onClose(); }}>
      <DialogContent className="max-w-6xl border-zinc-800 bg-[#101014]" data-testid="burst-compare-dialog">
        <DialogHeader>
          <DialogTitle>Ganadora y reservas de la ráfaga</DialogTitle>
          <DialogDescription>{reason || "Compara las tomas dudosas con la ganadora y elige la definitiva con un toque."}</DialogDescription>
        </DialogHeader>
        <div className={`grid gap-4 ${shown.length > 2 ? "md:grid-cols-3" : "md:grid-cols-2"}`}>
          {shown.map(p => (
            <figure key={p.id} data-testid={`compare-item-${p.name}`} className={`overflow-hidden rounded-xl border ${p.selectedForEdit ? "border-emerald-400 ring-1 ring-emerald-400/50" : "border-amber-400/50"}`}>
              <Thumbnail file={p.thumb ? null : p.file || p.previewFile} fallback={p.thumb} alt={p.name} className="aspect-[3/2] w-full" />
              <figcaption className="flex items-center justify-between gap-2 px-3 py-2">
                <span className="min-w-0">
                  <span className="block truncate font-mono text-[11px] text-zinc-400">{p.name}</span>
                  {p.selectedForEdit
                    ? <span className="text-xs font-semibold text-emerald-400">Ganadora · 5★ verde</span>
                    : <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-300"><Star className="h-3 w-3 fill-amber-300" /> Reserva · 3★ amarilla</span>}
                </span>
                {!p.selectedForEdit && (
                  <button data-testid={`compare-choose-${p.name}`} disabled={disabled} onClick={() => onChoose(p)}
                    className="inline-flex shrink-0 items-center gap-1 rounded-md bg-emerald-400 px-2.5 py-1 text-xs font-semibold text-zinc-950 transition-transform hover:scale-[1.03] disabled:opacity-50">
                    <Check className="h-3 w-3" /> Elegir esta
                  </button>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
